import React from "react";
import { FaApple } from "react-icons/fa";

const AppleLoginButton = () => {
  const handleAppleLogin = () => {

   const params = new URLSearchParams({
  client_id: "com.qritagya.login", // Service ID
  redirect_uri: "https://www.qritagya.com/app/api/auth/apple/callback",
  response_type: "code",
  scope: "name email",
  response_mode: "form_post"
});

window.location.href = `https://appleid.apple.com/auth/authorize?${params.toString()}`;

  };

  return (
    <button
      onClick={handleAppleLogin}
      className="d-flex align-items-center justify-content-center border rounded bg-white"
      style={{
        height: "33px",
        fontSize: "14px",
        fontWeight: 400,
        borderColor: "#dadce0",
        width: "100%",
      }}
    >
      <FaApple size={18} color="#000000" style={{ marginRight: "20px" }} />
      <span style={{ color: "#3c4043" }}>Sign in with Apple</span>
    </button>
  );
};

export default AppleLoginButton;
